import { Component, EventEmitter, Input, Output,OnInit } from '@angular/core';
import { AlertController, ModalController, LoadingController, ToastController, Platform } from '@ionic/angular';
  
  
import { Stylist } from '../../../../models/stylist/stylist.model';
import { ServiceCategory } from '../../../../models/service-category/service-category.model';
import { ServiceDefinition } from '../../../../models/service-definition/service-definition.model';
import { UserService } from '../../../../services/user.service';
import { ServiceCategoryService } from '../../../../services/service-category.service';
import { ServiceDefinitionService } from '../../../../services/service-definition.service';
import { Utilities } from '../../../../utilities/utilities';

import { IServiceCategorySelectEvent, IServiceDefinitionSelectEvent } from '../../../../components/service-definition-list/service-definition-list.component';
import { List } from 'immutable';
import { AlertService } from '../../../../utilities/alert.service';
import { ToastService } from '../../../../utilities/toast.service';
import { ServiceDetailFormComponent } from '../../service-detail-form/service-detail-form.component';

@Component({
  selector: 'smr-single-stylist-service-manager',
  templateUrl: './single-stylist-service-manager.component.html',
  styleUrls: ['./single-stylist-service-manager.component.scss'],
})
export class SingleStylistServiceManagerComponent implements OnInit {

  @Input() stylist: Stylist;

  public isLoading: boolean;

  public errorOccurredWhileLoadingServices: boolean;

  public salonServiceCategories: List<ServiceCategory>;

  public serviceCategoriesOffered: List<ServiceCategory>;

  public serviceCategoriesNotOffered: List<ServiceCategory>;

  public firstLoad: boolean;

  public viewingMyServices: boolean; 

  constructor (private modalCtrl: ModalController,
              private userService: UserService,
              private platform: Platform,
              private toastController: ToastController,
              private alertController: AlertController,
              private serviceDefinitionService: ServiceDefinitionService,
              private serviceCategoryService: ServiceCategoryService,
              private readonly alertService: AlertService,
              private loadingCtrl: LoadingController,
              private readonly toastService: ToastService) {
    this.salonServiceCategories = List([]);
    this.serviceCategoriesOffered = List([]);
    this.serviceCategoriesNotOffered = List([]);
    this.firstLoad = true;
    this.isLoading = true;
  }

  public ngOnInit () {
  }

  public ngOnChanges (changes) {
    if (changes) {
      if (changes['stylist']) {
        this.loadServices();
        this.viewingMyServices = this.userService.getUser().getID() === this.stylist.getID();
      }
    }
  }
  public ionViewDidEnter() {
    this.loadServices();
  }

  public loadServices (autoOpenServiceDetailID?: number) {
    if (this.stylist) {
      this.isLoading = true;
      this.errorOccurredWhileLoadingServices = false;
      
      // load service categories offered by this stylist
      this.serviceCategoryService.getServiceCategories(this.stylist.getID(),this.userService.getSalon().getId(), true)
      .subscribe({
        next: (serviceCategoriesOffered) => {
            this.serviceCategoriesOffered = serviceCategoriesOffered;

            // load all service categories of the salon on first load
            if (this.firstLoad) {
              this.serviceCategoryService.getSalonServiceCategories()
              .subscribe({
                next: (salonServiceCategories) => {
                  this.salonServiceCategories = salonServiceCategories;
                  this.showSalonServiceCategoriesNotOfferedByThisStylist();
                  this.firstLoad = false;
                  this.isLoading = false;
                },
                error: (e) => {
                  this.isLoading = false;
                  this.errorOccurredWhileLoadingServices = true;
                }
              });
            } else {
              this.showSalonServiceCategoriesNotOfferedByThisStylist();
              this.isLoading = false;
            }

            if (autoOpenServiceDetailID) {
              
              this.serviceCategoriesOffered.forEach((serviceCategory) => {

                serviceCategory.getServiceDefinitions().forEach((serviceDefinition) => {

                  if (autoOpenServiceDetailID === serviceDefinition.getID()) {
                    this.onServiceDefinitionSelect(serviceDefinition);
                  }

                });

              });

            }

          },
          error: (e) => {
            this.isLoading = false;
            this.errorOccurredWhileLoadingServices = true;
          }
        });
    }
  }

  public showSalonServiceCategoriesNotOfferedByThisStylist () {
    let myServiceParentIDs: List<number> = List([]);

    this.serviceCategoriesOffered.forEach((serviceCategory) => {
      myServiceParentIDs = myServiceParentIDs.concat(serviceCategory.getServiceDefinitions().map((serviceDefinition) => serviceDefinition.getParentID())).toList();
    });

    this.serviceCategoriesNotOffered = List([]);
    this.salonServiceCategories.forEach((salonServiceCategory: ServiceCategory) => {

      let serviceDefinitionsNotOffered: List<ServiceDefinition> = List([]);
      salonServiceCategory.getServiceDefinitions().forEach((serviceDefinition) => {

        if (!myServiceParentIDs.contains(serviceDefinition.getParentID())) {
          serviceDefinitionsNotOffered = serviceDefinitionsNotOffered.push(serviceDefinition);
        }
      });

      if (serviceDefinitionsNotOffered.count() > 0) {
        this.serviceCategoriesNotOffered = this.serviceCategoriesNotOffered.push(salonServiceCategory.setServiceDefinitions(serviceDefinitionsNotOffered));
      }
      

      // const salonServiceCategoryID: number = salonServiceCategory.getId();

      // if (myServiceCategoryIDs.contains(salonServiceCategoryID)) {

      // } else {

      // }

      // // check if this is not category is not offered by this stylst
      // const result = this.serviceCategoriesOffered.filter((stylistServiceCategory: ServiceCategory) => stylistServiceCategory.id === salonServiceCategory.id).toList();
      
      // if (result.count() === 0) {
        
      //   // add this salon service category
      //   // this.serviceCategoriesOffered = this.serviceCategoriesOffered.push(salonServiceCategory.setServiceDefinitions(List([])));

      //   this.serviceCategoriesNotOffered = this.serviceCategoriesNotOffered.push(salonServiceCategory.setServiceDefinitions(List([])));
      // }

    });
  }

  public async onAddAction () {
    const newServiceDefinition = new ServiceDefinition({
      id: undefined,
      parentID: undefined,
      categoryID: undefined,
      name: '',
      duration: 15,
      processDuration: 0,
      finishDuration: 0,
      price: 0,
      clientBookable: 1,
      stylist: this.stylist,
      description: '',
      startingAt: 0,
      serviceCategory: undefined
    });

    const serviceDefinitionEditModal = await this.modalCtrl.create({
      component:ServiceDetailFormComponent,
      componentProps:  {
      serviceDetail: newServiceDefinition,
      salonServiceCategories: this.salonServiceCategories,
      
    },
    backdropDismiss: false
    });

    serviceDefinitionEditModal.onDidDismiss().then(({data}) => {
      if (data) {
        this.loadServices();
      }
    });

    return await serviceDefinitionEditModal.present();
  }

  // public onServiceCategorySelect (serviceCategoryIndex: number, serviceCategory: ServiceCategory, $event) {
    // const serviceCategoryModal = this.modalCtrl.create("ServiceCategoryFormComponent", {
    //   serviceCategory: serviceCategory
    // });

    // serviceCategoryModal.onDidDismiss((serviceCategory: ServiceCategory) => {
    //   if (serviceCategory) {
    //     this.loadServices();
    //   }
    // });

    // serviceCategoryModal.present();
  // }

  public async onServiceDefinitionSelect (serviceDefinition: ServiceDefinition, $event?) {    

    if ($event) {
      $event.stopPropagation();
    }
  
    const serviceDefinitionEditModal = await this.modalCtrl.create({
    component:ServiceDetailFormComponent,
    componentProps:  { 
      serviceDetail: serviceDefinition,
      salonServiceCategories: this.salonServiceCategories,
      enableBackdropDismiss: false
    }

    });

    serviceDefinitionEditModal.onDidDismiss().then(({data}) => {
      if (data) {
        this.loadServices();
      }
    });

    return await serviceDefinitionEditModal.present();
  }

  public async addSalonServiceToMyServices (serviceDefinition: ServiceDefinition, $event) {
    $event.stopPropagation();

    serviceDefinition = serviceDefinition.setStylist(this.stylist);

        const loader = await this.loadingCtrl.create({
          spinner: 'crescent',
        });

      loader.present();
    this.serviceDefinitionService.offerSalonServiceDetail(serviceDefinition)
      .subscribe({
        next: (serviceDetailID: number) => {
          loader.dismiss().then(() => {
         // this.toastController.create({ message: `${serviceDefinition.getServiceName()} has been added to your services. You can now customize its prices and durations by selecting it from your service list`, position: 'middle', showCloseButton: true}).present();
         this.toastService.presentSimpleToast(`${serviceDefinition.getServiceName()} has been added to your services. You can now customize its prices and durations by selecting it from your service list`, 3000);
          this.loadServices(serviceDetailID);
        });
      },
      error: (e) => {
        loader.dismiss().then(() => {
          this.alertService.presentErrorAlert();
        });
      }
      });
  }

}
